namespace GeniuzPOS.Inventory {
    export class IcStockTransferDtColumns {
        static columnsKey = 'Inventory.IcStockTransferDt';
    }
}
